// extracted by mini-css-extract-plugin
export var productCard = "TextAndProduct-module--productCard---sqH0";
export var productContent = "TextAndProduct-module--productContent--fHVpe";
export var productWrapper = "TextAndProduct-module--productWrapper--yyOZB";
export var textContent = "TextAndProduct-module--textContent--2F9XI";
export var textWrapper = "TextAndProduct-module--textWrapper--qtQNX";
export var wrapper = "TextAndProduct-module--wrapper--xn5FI";